module.exports = __webpack_public_path__ + "img/3.2e98237c.png";